import { render, staticRenderFns } from "./PTPayrollComponent.vue?vue&type=template&id=05a9aa05"
import script from "./PTPayrollComponent.vue?vue&type=script&lang=js"
export * from "./PTPayrollComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports